import { DisclosureProps } from 'libs/contentful/props';
import DisclosureItem from './DisclosureItem';
import DisclosureSymbol from './DisclosureSymbol';
import { renderSuperscript } from 'utils/superscriptUtils';
import RichTextCopy from '../shared/RichTextCopy/RichTextCopy';

interface ExtendedDisclosureProps extends DisclosureProps {
  autoNumber?: number;
}

export type DisclosureNumberingMap = Map<string, number>;

const Disclosure = ({ symbol, copy, disclosureItem, disclosureSymbol, autoNumber }: ExtendedDisclosureProps) => {
  /*
  Determine which fields to use:
  - If new direct fields are present, use them (dynamic disclosures)
  - Otherwise, fall back to legacy fields (static disclosures)
  This supports a gradual migration from the legacy nested structure to the new flattened structure
  while maintaining backward compatibility with existing content.
  */
  const hasNewFields = symbol || copy;
  const hasLegacyFields = disclosureItem || disclosureSymbol;

  // Early return if no content to render
  if (!hasNewFields && !hasLegacyFields) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <div className={`flex text-left`}>
        <div className="flex flex-row items-start font-sans font-medium text-xs leading-[140%]">
          {hasNewFields ? (
            // Render using new direct fields
            <>
              {symbol && <span className="leading-[140%] static">{renderSuperscript(symbol)}&nbsp;</span>}
              {!symbol && autoNumber && (
                <span className="leading-[140%] static">{renderSuperscript(autoNumber)}&nbsp;</span>
              )}
              {copy?.json && (
                <div className="flex-1">
                  <RichTextCopy copy={copy} ySpacing={`sm`} />
                </div>
              )}
            </>
          ) : (
            // Render using legacy fields with proper components
            <>
              {disclosureSymbol && <DisclosureSymbol {...disclosureSymbol} />}
              {!disclosureSymbol && autoNumber && (
                <span className="leading-[140%] static">{renderSuperscript(autoNumber)}&nbsp;</span>
              )}
              {disclosureItem && <DisclosureItem {...disclosureItem} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default Disclosure;
